import React from 'react';
import { connect } from 'react-redux';

import { ReduxState } from '../../redux/modules/types';
import { RateLimitType } from '../../redux/modules/types/rate-limits';
import { formatMessage } from '../../utils/i18n';

type RateLimitedProps = {
  disabled?: boolean;
  error?: string;
};

type ParentProps = {
  children: (props: RateLimitedProps) => React.ReactElement;
};

type StateProps = {
  disabled?: boolean;
  type: RateLimitType;
};

type Props = ParentProps & StateProps;

const RateLimitedComponent = ({ children, disabled, type }: Props) => {
  const props: RateLimitedProps = {
    disabled,
    error: disabled ? formatMessage(`RateLimits.${type}`) : undefined,
  };

  return children(props);
};

const mapStateToProps = (state: ReduxState, ownProps: Props) => {
  const { rateLimits } = state;
  const { type } = ownProps;

  const limit = rateLimits && rateLimits[type];

  return {
    type,
    disabled: limit != null && limit.remaining <= 0,
  };
};

export default connect(mapStateToProps, null)(RateLimitedComponent);
